<template>
  <div
    class="preview"
    :class="[computedCharacterColorClass]"
  >
    <component
      v-if="true"
      :is="computedComponentName"
    />
  </div>
</template>

<script>
// 通常位牌 1霊
import N1East from "@/components/Common/TabletPreview/Items/ColorSamples/N1East/Back.vue";
import N1West from "@/components/Common/TabletPreview/Items/ColorSamples/N1West/Back.vue";
// 通常位牌 2霊
import N2East from "@/components/Common/TabletPreview/Items/ColorSamples/N2East/Back.vue";
import N2East2 from "@/components/Common/TabletPreview/Items/ColorSamples/N2East2/Back.vue";
import N2East3 from "@/components/Common/TabletPreview/Items/ColorSamples/N2East3/Back.vue";
import N2West from "@/components/Common/TabletPreview/Items/ColorSamples/N2West/Back.vue";
import N2West2 from "@/components/Common/TabletPreview/Items/ColorSamples/N2West2/Back.vue";
import N2West3 from "@/components/Common/TabletPreview/Items/ColorSamples/N2West3/Back.vue";
// 俗名位牌 1霊
import S1East from "@/components/Common/TabletPreview/Items/ColorSamples/S1East/Back.vue";
import S1West from "@/components/Common/TabletPreview/Items/ColorSamples/S1West/Back.vue";
// マインドアルテ 1霊
import M1A from "@/components/Common/TabletPreview/Items/ColorSamples/M1A/Back.vue";
import M1B from "@/components/Common/TabletPreview/Items/ColorSamples/M1B/Back.vue";
// マインドアルテ 2霊
import M2 from "@/components/Common/TabletPreview/Items/ColorSamples/M2/Back.vue";

// Mixins
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.component,
    TabletPreviewMixin.character,
  ],
  components: {
    N1East,
    N1West,
    N2East,
    N2East2,
    N2East3,
    N2West,
    N2West2,
    N2West3,
    S1East,
    S1West,
    M1A,
    M1B,
    M2,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-common.scss";
</style>
